// import { create } from "zustand";
// import { persist } from "zustand/middleware";

// export const useUserTopic = create()(
//   persist(
//     (set) => ({
//       data: {
//         duration: "",
//         level: "",
//         prepType: "",
//         focusArea: "",
//         userId: "",
//         uniqueId: "",
//         topic:""
//       },
//       setData: (arg) =>set((state) => ({ data: arg })),
//       resetData: () =>
//         set(() => ({
//           data: {
//             duration: "",
//             level: "",
//             prepType: "",
//             focusArea: "",
//             userId: "",
//             uniqueId: "",
//             topic:""
//           },
//         })),
//     }),
//     { name: "comm-skills-info" }
//   )
// );


import { create } from "zustand";

export const useUserTopic = create()(
  (set) => ({
    modules: {
      communication: null,
      debate: null,
      interview: null,
    },

    setModuleData: (module, payload) =>
      set((state) => ({
        modules: {
          ...state.modules,
          [module]: payload,
        },
      })),

    resetModuleData: (module) =>
      set((state) => ({
        modules: {
          ...state.modules,
          [module]: null,
        },
      })),

    resetAll: () =>
      set(() => ({
        modules: {
          communication: null,
          debate: null,
          interview: null,
        },
      })),
  }),
);
